<form
  [formGroup]="questionNotesForm"
  (ngSubmit)="onSubmit()">
<div class="card fixed-top w-100 h-100">
<div class="card-header">
<h5 class="card-title" ><button
  (click)="onCancel()"
  type="cancel"
  class="btn btn-outline-secondary float-end"
  >&times;</button>
{{ question.title }}</h5>
</div>
<div class="card-body">
  <textarea
    class="form-control w-100 h-100"
    formControlName="notes"
    >These are my notes</textarea>
</div>
<div class="card-footer">
<button
  type="submit"
  class="btn btn-primary float-end"
  i18n="Save">BUTTON_SAVE</button>
<button
  (click)="onCancel()"
  type="cancel"
  class="btn btn-primary"
  i18n="Cancel">BUTTON_CANCEL</button>
</div>
</div>
</form>
